export default __webpack_public_path__ + "static/media/SayantanChatterjee.2ad101ba.jpeg";